import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Link } from '@mui/material';
import { Lock, Security, Shield, CheckCircle, Info } from '@mui/icons-material';

import logo from '../../assets/imgs/logo.png';
import Forgot from './forgot';
import Login from './login';
import Recover from './reset';
import { Element, LeftColumn, RightColumn } from './styles';

const PageAuth = () => {
  const [action, setAction] = useState('login');
  const [params] = useSearchParams();

  const recoveryToken = params.get('recovery') || null;
  const firstAccess = params.get('firstAccess') === 'true' || false;

  const handleAction = (param) => {
    setAction(param);
  };

  const render = () => {
    if (recoveryToken) {
      return <Recover token={recoveryToken} firstAccess={firstAccess} />;
    }
    if (action === 'forgot') {
      return <Forgot handleAction={handleAction} />;
    }

    return <Login handleAction={handleAction} />;
  };

  return (
    <Element>
             <LeftColumn>
         <Box sx={{ 
           textAlign: 'center', 
           maxWidth: { xs: '100%', md: 800 },
           position: 'relative', 
           zIndex: 1
         }}>
           {/* Logo */}
           <Box sx={{ 
             mb: { xs: 1, md: 4 }
           }}>
             <Box
               component="img"
               src={logo} 
               alt="SOLIS" 
               sx={{
                 maxWidth: { xs: '200px', md: '400px' },
                 marginBottom: { xs: '10px', md: '20px' },
                 filter: 'brightness(0) invert(1)'
               }}
             /> 
           </Box>

           {/* Subtítulo */}
           <Typography
             variant="h5"
             sx={{
               fontWeight: 600,
               color: 'white',
               mb: { xs: 2, md: 4 },
               lineHeight: 1.3,
               fontSize: { xs: '1.25rem', md: '1.5rem' },
             }}
           >
             Bem-vindo(a) à SOLIS!
           </Typography>

                       {/* Descrição - oculta em mobile */}
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '18px',
                lineHeight: 1.6,
                mb: 4,
                display: { xs: 'none', md: 'block' },
              }}
            >
              Plataforma especializada em conformidade LGPD para entidades públicas. 
              Simplifique a gestão de proteção de dados e garanta a adequação legal 
              da sua organização com ferramentas especializadas.
            </Typography>

                         {/* Benefícios - ocultos em mobile */}
             <Box sx={{ 
               display: { xs: 'none', md: 'flex' }, 
               flexDirection: 'column', 
               gap: 2, 
               alignItems: 'flex-start', 
               maxWidth: 400, 
               mx: 'auto',
               mb: 4,
             }}>
               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                 <CheckCircle sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: 20 }} />
                 <Typography sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '16px' }}>
                   Conformidade completa com LGPD
                 </Typography>
               </Box>
               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                 <Shield sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: 20 }} />
                 <Typography sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '16px' }}>
                   Proteção avançada de dados pessoais
                 </Typography>
               </Box>
               <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                 <Security sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: 20 }} />
                 <Typography sx={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '16px' }}>
                   Gestão simplificada de compliance
                 </Typography>
               </Box>
             </Box>

             {/* Seção sobre a LGPD */}
             <Box sx={{ 
               display: { xs: 'none', md: 'block' },
               p: 3,
               backgroundColor: 'rgba(255, 255, 255, 0.1)',
               borderRadius: 2,
               border: '1px solid rgba(255, 255, 255, 0.2)',
             }}>
               <Typography
                 variant="h6"
                 sx={{
                   color: 'white',
                   fontWeight: 600,
                   mb: 2,
                   textAlign: 'center',
                 }}
               >
                 📋 Lei Geral de Proteção de Dados
               </Typography>
               
               <Typography
                 variant="body2"
                 sx={{
                   color: 'rgba(255, 255, 255, 0.9)',
                   fontSize: '14px',
                   lineHeight: 1.5,
                   mb: 2,
                 }}
               >
                 A <strong>LGPD</strong> é a legislação brasileira que regula o tratamento de dados pessoais, 
                 garantindo maior controle aos cidadãos sobre suas informações e estabelecendo 
                 obrigações para organizações públicas e privadas.
               </Typography>

               <Typography
                 variant="body2"
                 sx={{
                   color: 'rgba(255, 255, 255, 0.9)',
                   fontSize: '14px',
                   lineHeight: 1.5,
                   mb: 2,
                 }}
               >
                 <strong>Entidades públicas</strong> têm obrigação legal de adequar seus processos 
                 e sistemas para garantir a proteção dos dados pessoais dos cidadãos, 
                 implementando políticas de privacidade e controles de acesso.
               </Typography>

               <Typography
                 variant="body2"
                 sx={{
                   color: 'rgba(255, 255, 255, 0.9)',
                   fontSize: '14px',
                   lineHeight: 1.5,
                 }}
               >
                 A <strong>SOLIS</strong> oferece soluções especializadas para ajudar prefeituras 
                 e órgãos governamentais a cumprir todas as exigências da LGPD de forma 
                 eficiente e transparente.
               </Typography>

               {/* Link para mais informações */}
               <Box sx={{ 
                 textAlign: 'center', 
                 mt: 2,
                 pt: 2,
                 borderTop: '1px solid rgba(255, 255, 255, 0.2)',
               }}>
                 <Link
                   href="https://www.gov.br/esporte/pt-br/acesso-a-informacao/lgpd"
                   target="_blank"
                   rel="noopener noreferrer"
                   sx={{
                     color: 'rgba(255, 255, 255, 0.9)',
                     textDecoration: 'none',
                     display: 'flex',
                     alignItems: 'center',
                     justifyContent: 'center',
                     gap: 1,
                     fontSize: '14px',
                     fontWeight: 500,
                     '&:hover': {
                       color: 'white',
                       textDecoration: 'underline',
                     },
                   }}
                 >
                   <Info sx={{ fontSize: 16 }} />
                   Saiba mais sobre a LGPD
                 </Link>
               </Box>
             </Box>
         </Box>
       </LeftColumn>

      <RightColumn>
      {render()}
      </RightColumn>
    </Element>
  );
};

export default PageAuth;
